<template>
<div class="main department-links">

	<div class="list-view">

		<div class="sub-header">
			<div class="input-with-control">
				<input type="search" ref="search_term" v-model="filters.search_term" placeholder="Search..." @search="getList()" v-focus>
				<div class="button action input-go" @click="getList()"><i class="fas fa-search"></i></div>
			</div>
			<div class="controls">
				<pagination :paging="paging" @updatePage="goToPage"></pagination>
			</div>
		</div>

		<div v-if="showFilters" class="left-sidebar filters">

			<div v-if="!autoPilotEnabled" class="title">Filter department links by published/unpublished...</div>

			<ul v-if="!autoPilotEnabled" class="checkbox-group">
				<li>
					<span :class="['pointer', 'far', filters.published ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('published')"></span>
					<label>Published</label>
				</li>
				<li>
					<span :class="['pointer', 'far', filters.unpublished ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('unpublished')"></span>
					<label>Unpublished</label>
				</li>
				<div :class="['button', hasFilters ? 'neutral' : 'disabled' ]" @click="clearFilters(true)">Clear Filters</div>
			</ul>

			<div v-if="autoPilotEnabled" class="label">
				<p>These department links are part Auto Pilot and cannot be changed.</p>
				<router-link to="/website/auto-pilot">Manage Auto Pilot...</router-link>
			</div>

		</div>

		<div class="detail" v-if="!loading">
			<div v-if="department_links.length > 0" class="list-grid">
				<div v-for="department_link in department_links" class="cell">
					<div style="text-align: center;">
						<img :src="department_link.image_src">
					</div>
					<button v-if="!autoPilotEnabled && !department_link.client_department_link_id" class="primary" style="float: right;" @click="saveDepartmentLink(department_link.department_link_id)">Publish</button>
					<button v-else-if="!autoPilotEnabled" class="delete" style="float: right;" @click="saveDepartmentLink(department_link.department_link_id)">Unpublish</button>
					<div class="title">{{ department_link.description }}</div>
					<div class="meta">{{ department_link.link_url }}</div>
				</div>
			</div>
			<div v-else class="empty-list">
				This list is empty
			</div>

		</div>
        <loading class="main-content" v-else></loading>
	</div>

	<help-popup :helpLink="{85:'Department Links', 108:'Website Template: Department Links Section'}" :tours="false"></help-popup>

</div>
</template>

<script>
import HelpPopup from '@/components/HelpPopup.vue'

export default {
	name: 'department-links',
	components: {
		'help-popup': HelpPopup
    },
	data() {
		return {
			loading: false,
			showFilters: true,
			filters: {
				page: 1,
				search_term: '',
				published: false,
				unpublished: false
			},
			paging: {},
			message: '',
			clientId: '',
			department_links: [],
			autoPilotEnabled: false
		}
	},
	created() {
		this.getAutoPilotEnabled()
		this.getList()
	},
	computed: {
		hasFilters() {
			let filterIsSet = false
			for (var property in this.filters) {
				switch (property) {
					case 'hostname':
					case 'page':
					case 'source':
					case 'shopping_cart_id':
						break
					default:
						filterIsSet = this.filters[property] && this.filters[property] != ''
						break
				}
				if (filterIsSet) {
					return true
				}
			}
			return false
		}
	},
	methods: {
		getAutoPilotEnabled() {
			this.apiCall({ destination: 'get_item_preference', data: { preference_code: 'ENABLE_AUTO_PILOT' } }).then(obj => {
				this.autoPilotEnabled = obj.ENABLE_AUTO_PILOT != ''
			}).catch(err => {
				console.log(err)
			})
		},
		getList() {
			this.loading = true
			this.apiCall({ destination: 'get_list_department_links', data: this.filters } ).then(obj => {
				this.loading = false
				this.department_links = obj.department_links
			}).catch(err => {
				console.log(err)
			})
		},
		toggleFilter(which) {
			let currentValue = this.filters[which]
			this.filters.published = ''
			this.filters.unpublished = ''
			this.filters[which] = !currentValue
			this.filters.page = 1
			this.getList()
		},
		clearFilters(getList) {
			this.filters = {
				page: 1,
				search_term: '',
				published: false,
				unpublished: false
			}
			if (getList) {
				this.getList()
			}
		},
		goToPage(page) {
			this.filters.page = page
			this.getList()
		},
		saveDepartmentLink(index) {
			this.loading = true
			this.apiCall({ destination: 'save_item_department_link', data: { department_link_id: index } } ).then(obj => {
				this.loading = false
				if (obj.status == 'success') {
					for (let i = 0; i < this.department_links.length; i++) {
						if (this.department_links[i]['department_link_id'] == index) {
							this.department_links[i]['client_department_link_id'] = obj.client_department_link_id
							break;
						}
					}
				}
			}).catch(err => {
				console.log(err)
			})
		}
	}
}
</script>

<style lang="scss" scoped>
</style>
